import React from 'react';
import { Text, Whitespace } from '../common';
import Input from '../common/FormComponents/InputStyle';
import Button from '../common/FormComponents/Button';
import TrustItems from '../../components/Trust/TrustItems';
import { getp } from '../../helpers/getProp';

export default function(props) {
  const { next, userStore, resendEmail, emailResent, isOnboarding } = props;
  console.log('EMAIL VERIFICATION : userStore', userStore);
  return (
    <div className={'f f-center-stretch f-rows'}>
      <Whitespace smaller />
      <TrustItems inline />
      <Whitespace small />
      <Text bold noclip mb={3}>
        You must complete all 3 steps before renting to be eligible for
        insurance. {isOnboarding && 'Only phone number is required right now.'}
      </Text>
      <Button
        primary
        onClick={next}
        className="m-mxx"
        disabled={
          !getp(userStore, 'isPhoneVerified') &&
          !userStore.isPhoneVerified
        }
      >
        {isOnboarding ? 'Next' : 'Done'}
      </Button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components_new/verification/EmailVerification.js